import { OutlinedEditFilter } from '@hose/eui-icons';
import { Button, Input } from '@hose/eui';
import React from 'react';
var Search = Input.Search;
var getColumnSearch = function (cellRender) {
    var handleSearch = function (selectedKeys, confirm) {
        confirm();
    };
    var handleReset = function (clearFilters) {
        clearFilters();
    };
    return {
        filterDropdown: function (_a) {
            var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
            return (React.createElement("div", { style: { padding: 4, width: '264px' }, onKeyDown: function (e) { return e.stopPropagation(); } },
                React.createElement(Search, { placeholder: "\u641C\u7D22\u7B5B\u9009", value: selectedKeys[0], onChange: function (e) { return setSelectedKeys(e.target.value ? [e.target.value] : []); }, style: { marginBottom: 8 } }),
                React.createElement("div", { style: { width: '100%', display: 'flex', justifyContent: 'end' } },
                    React.createElement(Button, { category: "secondary", onClick: function () { return clearFilters && handleReset(clearFilters); }, size: "small", style: { width: 40, marginRight: '4px' } }, "\u91CD\u7F6E"),
                    React.createElement(Button, { category: "primary", onClick: function () { return handleSearch(selectedKeys, confirm); }, size: "small", style: { width: 40 } }, "\u786E\u8BA4"))));
        },
        filterIcon: function () { return (React.createElement(OutlinedEditFilter, { fontSize: 16, style: { color: 'var(--eui-icon-n2)' } })); },
        render: cellRender
    };
};
export default getColumnSearch;
